import { timeAgo } from "@/helpers/time";

import dayjs from "dayjs";

import Tooltip from "./tooltip";

const TimeAgo = ({ date }: { date?: string }) => {
  if (!date) return null;

  const timeAgoText = timeAgo(date);

  return (
    <Tooltip content={dayjs(date).format("DD-MM-YYYY HH:mm:ss")}>
      <span>{timeAgoText}</span>
    </Tooltip>
  );
};

export default TimeAgo;
